import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../../payments/services/payment.service';

@Component({
  selector: 'pk-payment-loader',
  templateUrl: './payment-loader.component.html',
  styleUrls: ['./payment-loader.component.scss']
})
export class PaymentLoaderComponent implements OnInit {

  constructor(public payment: PaymentService) { }

  ngOnInit() {}

}
